export default __webpack_public_path__ + "static/03-03fc4fcbd65934acb86a6f55b27627dd.jpg";